export const HAKLAI_ANALYSIS_RESULTS_LABELS = Object.freeze({
  residential: "בית מגורים",
  commercial: "נכס מסחרי",
  landAndShared: "קרקע ומשותף",
  farmRemainder: "יתרת המשק",
  propertyType: "סוג הנכס",
  saleValue: "שווי מכירה",
  nominalAcquisitionPrice: "שווי רכישה",
  indexedAcquisitionPrice: "שווי רכישה ממודד",
  nominalExpenses: "הוצאות",
  indexedExpenses: "הוצאות ממודד",
  depreciation: "פחת לניכוי",
  propertyShevach: "סה״כ שבח",
  partTax: "מס שבח",
  tableTotal: "סה״כ",
  adjustmentReason: "הפחתה בגין",
  showAdjustments: "פירוט",
  genericAsset: "נכס",
  singleApartmentExemption: "פטור דירה יחידה",
  inheritanceExemption: "פטור ירושה",
  totalShevach: "סה״כ שבח בעסקה",
  capitalGainsTax: "סה״כ מס שבח",
  totalTaxToPay: "סה״כ מס שבח לתשלום",
  businessLossOffset: "קיזוז עסקי",
  capitalLossOffset: "קיזוז הוני",
  rabinovichDiscount: "הנחת רבינוביץ",
  prisaYears: "שנות פריסה",
  prisaSavings: "חיסכון פריסה",
  prisaTaxAfterPrisa: "סה״כ מס שבח לאחר פריסה",
  afkaaCredit: "זיכוי הפקעה",
  resultsTitle: "תוצאות חישוב",
  backToCalc: "חזרה להזנת נתונים",
  calcDetails: "פירוט חישוב",
  variantKind: "סוג",
  variantValue: "חיסכון",
  savingsTotal: "סה״כ חיסכון",
  summary: "סיכום"
});

export const HAKLAI_ANALYSIS_RESULTS_MESSAGES = Object.freeze({
  noResults: "עדיין אין תוצאות להצגה. יש לחזור למסך החישוב וללחוץ על נתח.",
  inconsistentResults:
    "התוצאות השמורות אינן תואמות לסיכום העסקה. יש לחזור למסך החישוב ולהריץ ניתוח מחדש."
});
